import { FC } from "react";
import styled, { css } from "styled-components";

const SideBackground: FC = () => {
  return (
    <Root>
      <LeftBack />
      <RightBack />
    </Root>
  );
};

export default SideBackground;

const Root = styled.div`
  position: absolute;
  width: 100%;
  top: 61vw;
  left: 0;
  z-index: 0;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  @media screen and (max-width: 960px) {
    top: 170vw;
  }

  @media screen and (max-width: 350px) {
    height: 357vw;
  }
  @media screen and (min-width: 351px) {
    height: 356vw;
  }
  @media screen and (min-width: 461px) {
    height: 361vw;
  }
  @media screen and (min-width: 501px) {
    height: 359vw;
  }
  @media screen and (min-width: 601px) {
    height: 357vw;
  }
  @media screen and (min-width: 701px) {
    height: 356vw;
  }
  @media screen and (min-width: 801px) {
    height: 355vw;
  }
  
  @media screen and (min-width: 961px) {
    height: 23%;
    top: 62vw;
  }
  @media screen and (min-width: 1001px) {
    height: 23.5%;
    top: 62vw;
  }
  @media screen and (min-width: 1111px) {
    height: 23.2%;
  }
  @media screen and (min-width: 1281px) {
    height: 22.5%;
  }
  @media screen and (min-width: 1501px) {
    height: 22.5%;
  }
  @media screen and (min-width: 1751px) {
    height: 22%;
  }
  @media screen and (min-width: 2001px) {
    height: 21.5%;
  }
  @media screen and (min-width: 2251px) {
    height: 20.5%;
  }
  @media screen and (min-width: 2801px) {
    height: 19.5%;
  }
`;

const sideBack = css`
  height: 100%;
  width: 4%;
  max-width: 350px;
  background-size: contain;
`;

const LeftBack = styled.div`
  ${sideBack};
  background-image: url("/image/lp/kaleido/bg/long/bg_side_pink.png");
`;

const RightBack = styled.div`
  ${sideBack};
  background-image: url("/image/lp/kaleido/bg/long/bg_side_pink.png");
`;
